import { render, staticRenderFns } from "./NoContentView.vue?vue&type=template&id=2257193a"
import script from "./NoContentView.vue?vue&type=script&lang=js"
export * from "./NoContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports